import { FC } from 'react';

interface iExampleProps {
  content: string;
}

const Example: FC<iExampleProps> = ({ content }) => {
  return (
    <div className='example-wrapper'>
      <label>(EXAMPLE)</label>
      <div className='popup'><img src={`/images/examples/${content}.jpg`} alt="" /></div>
    </div>
  );
};

export default Example;
